exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-6380f5c8]{position:relative}.button__change[data-v-6380f5c8]{background:#2f23d6;padding:4px 12px;border:none;border-radius:4px!important;transition:.2s}.button__change[data-v-6380f5c8]:hover{background:#1d12b9}.button__change>.button__content[data-v-6380f5c8]{display:flex;align-items:center;flex-direction:row;color:#fff;font-size:13px;font-weight:400;line-height:140.62%}.button__change>.button__content ion-icon[data-v-6380f5c8]{margin-left:13px;font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6380f5c8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/buttons/btnChange.vue
// module id = 566
// module chunks = 0